import { useEffect, useState, useCallback } from "react";
import { Space, Text } from "@mantine/core";

import TextInputRef from "../TextInputRef";
import SelectInputRef from "../SelectInputRef";
import {
  translateItemMaterial,
  translateItemType,
} from "../../utils/translation.utils";
import { getMaterialTraceabilityOfItem } from "../../utils/material-traceability.utils";
import { MaterialTraceability } from "../../types/interfaces";
import { ItemType } from "../../types/enums";

const UpdateItemMaterialBrandAndLotNumberComponent = ({
  item,
  product,
  errors,
  control,
  watch,
  getValues,
  allMaterialTraceability,
}) => {
  const [
    showSecondMaterialLotNumberInput,
    setShowSecondMaterialLotNumberInput,
  ] = useState<boolean>(false);
  const watchMaterialBrand = watch(`${item?.id}.materialBrand`);

  const getMaterialTraceabilityLabel = useCallback(material => {
    if (material.translatedName) {
      return material.translatedName;
    }
    if (material?.secondMaterialApprovalReference) {
      return `${material.firstMaterialReference} - ${material.firstMaterialApprovalReference} - ${material.firstMaterialBrand} - ${material.firstMaterialCountry} ; ${material.secondMaterialReference} - ${material.secondMaterialApprovalReference} - ${material.secondMaterialBrand} - ${material.secondMaterialCountry}`;
    }
    return `${material.firstMaterialReference} - ${material.firstMaterialApprovalReference} - ${material.firstMaterialBrand} - ${material.firstMaterialCountry}`;
  }, []);

  useEffect(() => {
    const materialTraceabilitySelected = allMaterialTraceability.find(
      (materialTraceability: MaterialTraceability) =>
        materialTraceability.id === getValues(`${item.id}.materialBrand`)
    );
    if (
      getValues(`${item.id}.secondMaterialLotNumber`) ||
      materialTraceabilitySelected?.secondMaterialApprovalReference
    ) {
      setShowSecondMaterialLotNumberInput(true);
    }
  }, [watchMaterialBrand]);

  const itemMaterialTraceabilityChoices = getMaterialTraceabilityOfItem(
    item,
    allMaterialTraceability
  ).map(material => ({
    value: material.id,
    label: getMaterialTraceabilityLabel(material),
  }));

  if ((itemMaterialTraceabilityChoices ?? []).length === 0) {
    return null;
  }

  return (
    <>
      <Text style={{ textAlign: "center", fontWeight: "bold" }}>
        {`Item
        ${translateItemType(item?.itemType ?? product?.productType)} 
        with material ${translateItemMaterial(item?.itemType === ItemType.INLAY_CORE ? item?.inlayCoreMaterial?.id : item?.itemMaterial?.id)}`}
      </Text>
      <Space h="md" />
      <TextInputRef
        name={`${item.id}.lotNumber`}
        label="First Material lot number"
        errors={errors}
        control={control}
      />
      <Space h="md" />
      {showSecondMaterialLotNumberInput && (
        <>
          <TextInputRef
            name={`${item.id}.secondMaterialLotNumber`}
            label="Second material lot number"
            errors={errors}
            control={control}
            required={showSecondMaterialLotNumberInput}
          />
          <Space h="md" />
        </>
      )}
      <SelectInputRef
        name={`${item.id}.materialBrand`}
        data={itemMaterialTraceabilityChoices}
        label="Material brand"
        errors={errors}
        control={control}
      />
      <Space h="md" />
    </>
  );
};

export default UpdateItemMaterialBrandAndLotNumberComponent;
